import Vue from 'vue'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import router from './router'
import store from './store/'
import './plugins/base'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import interceptorsSetup from '@/helpers/interceptors'

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  hideProgressBar: true,
}
Vue.use(Toast, {
  options: toastOptions,
  maxToasts: 5,
  newestOnTop: true,
  containerClassName: 'toaster-container',
  toastClassName: 'na-toaster',
})

Vue.use(VueTelInputVuetify, { vuetify })

Vue.config.productionTip = false

if (process.env.VUE_APP_ANALYTICS) {
  Vue.use(VueGtag, {
    config: { id: 'UA-77912240-10' },
  }, router)
}

const params = (new URL(document.location)).searchParams
const isDashboard = params.get('dashboard')
if (isDashboard) store.commit('setFromDashboard')

interceptorsSetup()

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}
